import { restApi } from '../../services/Api'
import { createBasicLoopbackRepository as createRepository } from 'elentari'
import { paginate } from '../../lib/loopback'

const comentariosRepository = createRepository({
  path: 'comentarios',
  restApi,
  queryTransform: {
    ...paginate
  }
})

comentariosRepository.createByChatToken = (token, body) => {
  return restApi.post(`/comentarios/${token}`, body)
}

comentariosRepository.createByJWT = (solicitacaoId, body) => {
  return restApi.post(`solicitacoes/${solicitacaoId}/comentarios`, body)
}

export default comentariosRepository
